/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import Content from '../../atoms/Content';
import Heading from '../../atoms/Heading';
import styles from './NumberedHeadingContent.module.scss';

/**
 * Numbered headings with content blocks
 *
 * TODO: Find a better name.. feels like content/NumberedHeadingContent is a lot of content
 */
export default function NumberedHeadingContent({ items, headingProps, offset }) {
  return (
    <div className={styles['numbered-heading-content']}>
      {items && items.map((item, index) => (
        <div key={index}>
          <div className={styles['numbered-heading-content__header']}>
            <div className={styles['numbered-heading-content__circle']}>
              {index + offset + 1}
            </div>
            <Heading {...headingProps} anchor={item.anchor}>{item.heading}</Heading>
          </div>
          <Content>
            {item.content}
          </Content>
        </div>
      ))}
    </div>
  );
}

NumberedHeadingContent.defaultProps = {
  headingProps: {
    tag: 'div',
    type: 'h4',
  },
  offset: 0,
};

NumberedHeadingContent.propTypes = {
  headingProps: PropTypes.shape(Heading.propTypes),
  offset: PropTypes.number,
};
